<template>
  <div
    class="successfully"
    :style="{ height: 'calc(100vh - 60px)', overflowY: 'auto' }"
  >
    <Icon style="font-size: 70px; color: #0a4dcc;margin-top:215px" type="ios-checkmark-circle" />
    <div class="title">{{ $t("successfully.title") }}</div>
    <div class="tip">
      {{ $t("successfully.tipa") }}
      <span style="color: #0a4dcc">{{ $t("successfully.tipb") }}</span>
      {{ $t("successfully.tipc") }}
    </div>
    <div class="options common-flex common-justify-center">
      <Button style="background: #b0b5bf; margin-right: 15px">{{
        $t("successfully.no")
      }}</Button>
      <Button style="background: #0a4dcc">{{ $t("successfully.yes") }}</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "successfully",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.successfully {
  font-family: Roboto;
  .title {
    font-size: 24px;

    font-weight: 600;
    text-align: center;
    color: #081938;
    line-height: 32px;
    margin: 20px auto 15px;
  }
  .options {
    Button {
      width: 160px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      border-radius: 0;
    }
  }
  .tip {
    width: 377px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: rgba(8, 25, 56, 0.4);
    line-height: 22px;
    margin: 0 auto 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/successfully/successfully.vue